import { type TestSuiteScenario } from 'components/test-suites/forms/test-suite-form-utils'
import { type ScenarioForTestSuite } from 'components/test-suites/forms/TestSuiteFormContext'
import { type Team } from 'types/api/teams'

/**
 * These values allow for easier filtering on the TestSuiteScenarioOption.
 * The `filterBy` property will contain one of these values after calculation.
 */
export enum ScenarioTypeFilterBy {
  MyTeam = 'MyTeam',
  OtherTeams = 'OtherTeams',
  RecommendedAndShared = 'RecommendedAndShared'
}

export type TestSuiteScenarioOption = {
  filterBy: ScenarioTypeFilterBy
  guid: string
  label: string
  orgId: string | undefined
  owningTeamLabel: string | null
  section: string
}

/**
 * Filtering works by checking the `filterBy` key on the available scenarios.
 * If the menu selection is "All", then it ignores the `filterBy` and shows all options.
 */
export type FilterOptionKey = ScenarioTypeFilterBy | 'all'

export const FILTER_OPTIONS: {
  key: FilterOptionKey
  label: string
}[] = [
  {
    key: 'all',
    label: 'All'
  },
  {
    key: ScenarioTypeFilterBy.MyTeam,
    label: 'My Team'
  },
  {
    key: ScenarioTypeFilterBy.RecommendedAndShared,
    label: 'Recommended & Shared'
  },
  {
    key: ScenarioTypeFilterBy.OtherTeams,
    label: 'Other Teams'
  }
]

export function getScenarioFilterBy(isCurrentTeam: boolean, owningTeam?: Team) {
  if (isCurrentTeam) {
    return ScenarioTypeFilterBy.MyTeam
  }

  if (!isCurrentTeam && owningTeam) {
    return ScenarioTypeFilterBy.OtherTeams
  }

  return ScenarioTypeFilterBy.RecommendedAndShared
}

/** Adds type-safety to TestSuiteTestDetailsDrawer data corresponding to the component mode (isEdit vs new) */
export function getComponentDataFromDrawerMode(
  scenario: ScenarioForTestSuite | undefined,
  testToEdit: TestSuiteScenario | undefined
) {
  if (!scenario && !testToEdit) return

  if (testToEdit) {
    // "editing"
    return {
      isEdit: true,
      scenario,
      testToEdit
    } as const
  }

  if (scenario) {
    // "new"
    return {
      isEdit: false,
      scenario
    } as const
  }
}
